import { render, staticRenderFns } from "./ReferenceData.vue?vue&type=template&id=9d378c18&scoped=true"
import script from "./ReferenceData.vue?vue&type=script&lang=js"
export * from "./ReferenceData.vue?vue&type=script&lang=js"
import style0 from "./ReferenceData.vue?vue&type=style&index=0&id=9d378c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d378c18",
  null
  
)

export default component.exports